export const GOOGLE_SATELLITE_DEFAULT_ATTRIBUTION =
  '<div style="color:#fff">Map data ©2025 Google</div>';
export const GOOGLE_ROADMAP_DEFAULT_ATTRIBUTION = 'Map data ©2025 Google';
